import React, { Component } from 'react';
import classes from './NovedadesConteiner.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Novedad from './Novedad.js'


export class NovedadesConteiner     extends Component {
    render() {
        return (
            
            <div style={{padding: '3% 6%'}} >

                <h2 className="inicio-title">NOVEDADES ART</h2><p/> <p/> 
                
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        <div className='col-md-4'>
                            <Novedad/>
                        </div>
                        
                    </div>
                        
                </div>
            </div>
           
        )
    }
}

export default NovedadesConteiner
